/**
 * index.tsx - Application entry point.
 *
 * Renders the root <App /> component into the DOM and registers the
 * service worker for PWA offline support. The SW caches static assets
 * and enables the app shell to load without a network connection.
 *
 * Service worker registration is enabled (register) instead of the
 * CRA default (unregister) so that:
 *	 - Static assets are precached after the first visit
 *	 - The app shell loads offline on subsequent visits
 *	 - Runtime caching strategies handle API and image requests
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// Register the service worker for PWA offline support.
// onSuccess fires when the SW has cached all assets for the first time.
// onUpdate fires when a new SW version is available and waiting to activate.
serviceWorkerRegistration.register({
	onSuccess: () => {
		console.log('Service worker installed: app is now available offline.');
	},
	onUpdate: (registration) => {
		console.log('New app version available. Close all tabs to update.');
		// Optionally, force the waiting SW to activate immediately
		if (registration.waiting) {
			registration.waiting.postMessage({ type: 'SKIP_WAITING' });
		}
	},
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
